import { gql } from '@/features/graphql/generated'

export const DeliveryPaymentMappingsQuery = gql(/* GraphQL */ `
    query DeliveryPaymentMappings {
        deliveryPaymentMappings {
            ...DeliveryPaymentMapping
        }
    }
`)

export const AutomaticContainerSettingsQuery = gql(/* GraphQL */ `
    query AutomaticContainerSettings {
        automaticContainerSettings {
            deliveryTypeCategory
            attachAutomatically
        }
    }
`)
